import styled from "styled-components";
import { Link } from "react-router-dom";
import { Column } from "../../AppStyle";

export const FooterWrapper = styled.div`
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px; 

  @media screen and (max-width: 999px) {
    text-align: left;
  }
`;

export const FooterColumn = styled(Column)`
  @media screen and (max-width: 999px) {
    align-items: center;
    grid-column: 1/-1;
  }
`;

export const FooterLogo = styled(Link)`
  color: #fff;
  justify-self: start;
  cursor: pointer;
  text-decoration: none;
  font-size: 2rem;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const SocialIcon = styled.img`
  width: 80px;
  margin-right: 10px;
`;

export const FooterSocialGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2em;
  align-items: center;
  margin-top: 1.5em;
`;

export const FooterSocialIcon = styled.a`
  color: ${({ isDarkMode }) => (isDarkMode ? "#000" : "#fff")};
  font-size: 18px;
  padding: 5px;
  background-color: ${({ isDarkMode }) => (isDarkMode ? "#DDDF22" : "#000")};
  border-radius: 50px;
  display: flex;
`;

export const FooterAddress = styled.div`
  color: ${({ isDarkMode }) => (isDarkMode ? "#fff" : "#000")};
  margin: 0.4rem auto 0.4rem;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.2rem;
  text-align: left;
  font-family: "Roboto", "Montserrat", sans-serif;

  @media screen and (min-width: 1000px) {
    margin-left: 0px;
    text-align: left;
    margin-right: 1rem;
  }
`;
